import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noPermissionToCreateCategoryTitle: {
		id: 'business-list.list-view.category-cell.edit-category-cell.create-error-flag.no-permission-to-create-category-title',
		defaultMessage: 'Unable to add category',
		description: 'Title shown in error flag when user does not have permissions to create category',
	},
	noPermissionToCreateCategory: {
		id: 'business-list.list-view.category-cell.edit-category-cell.create-error-flag.no-permission-to-create-category',
		defaultMessage: "To add a category, you'll need to {contactAdmin}",
		description:
			'Message shown in error flag when user does not have permissions to create category',
	},
	createCategoryNoPermissions: {
		id: 'business-list.list-view.category-cell.edit-category-cell.create-error-flag.create-category-no-permissions',
		defaultMessage: "To add a category, you'll need to {linkStart}contact your admin{linkEnd}",
		description:
			'Message shown in error flag when user does not have permissions to create category',
	},
	contactAdmin: {
		id: 'business-list.list-view.category-cell.edit-category-cell.create-error-flag.contact-admin',
		defaultMessage: 'contact your admin',
		description: 'Clickable link that will redirect user to contact admin page',
	},
});
